export default "__VITE_ASSET__152affba__"